import { render, staticRenderFns } from "./DocumentRequestSelector.vue?vue&type=template&id=08ae3e5b&lang=pug"
import script from "./DocumentRequestSelector.vue?vue&type=script&lang=js"
export * from "./DocumentRequestSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports